export const getTypeTitle = (typeId: string): string => {
  switch (typeId) {
    case "circuit":
      return "Circuit de";
    case "circuit-croisiere":
      return "Circuit-Croisière de";
    case "croisiere":
      return "Croisière de";
    case "escapes":
      return "Echappées culturelles de";
    case "pelerinage":
      return "Pèlerinage de";
    case "pelerinage-croisiere":
      return "Pèlerinage Croisière de";
    case "sejour":
      return "Séjour de";
    case "sejour-un-jour":
      return "Journée";
    default:
      return "";
  }
};
